/**
 * Created by Ram on 12/05/2017.
 */

import React, { Component, Fragment } from 'react';
import MatrixTable from './MatrixAnalysis/MatrixTable';
import MatrixStartupTable from "./MatrixAnalysis/MatrixStartupTable";
import MatrixInfoPanel from './MatrixAnalysis/MatrixInfoPanel';
import MatrixDeviceTable from './MatrixAnalysis/MatrixDeviceTable';
import MatrixZoneTable from './MatrixAnalysis/MatrixZoneTable';
import MatrixFalseTriggerTable from './MatrixAnalysis/MatrixFalseTriggerTable';
import MatrixAnalysisMenu from './MatrixAnalysis/MatrixAnalysisMenu';
import MatrixTimeToTriggerTable from './MatrixAnalysis/MatrixTimeToTriggerTable';
import MatrixTimeToTriggerMenu from "./MatrixAnalysis/MatrixTimeToTriggerMenu";
import MatrixDwellTimeTable from './MatrixAnalysis/MatrixDwellTimeTable';
import {ScenarioTypes} from '../../enum/ScenarioEnum'

class MatrixAnalysis extends Component {
    render() {
        let {
            devices,
            zones,
            triggers,
            dwellEvents,
            displayAsIcons,
            showSinglePercentage,
            displayTableByPlatform,
            readTriggersDataFromLogs,
            testInstance,
            sortDevices,
            sortDevicesAsc,
            sortZones,
            sortZonesAsc,
            showPanels,
            isLoading,
            tttMetric
        } = this.props.loadData;

        let devicesShowing, zonesShowing;

        // TODO: refactor as this is modifying props
        const devicesByOs = devices.filter(
            device => device.os === displayTableByPlatform || displayTableByPlatform === 'Both',
        );

        devicesShowing = devicesByOs.filter(({ isShowing }) => isShowing);
        zonesShowing = zones.filter(({ isShowing }) => isShowing);

        // Setting up the objects
        const triggerCounts = {};

        triggerCounts.device = {};
        devicesShowing.forEach(device => {
            triggerCounts.device[device._id] = {
                miss: 0,
                over: 0,
                single: 0,
                shouldExit: 0,
                didExit: 0,
                tttTotal: 0,
                averageTTT: 0
            };
        });

        triggerCounts.zone = {};
        zonesShowing.forEach(zone => {
            triggerCounts.zone[zone._id] = {
                miss: 0,
                over: 0,
                single: 0,
                shouldExit: 0,
                didExit: 0,
                tttTotal: 0
            };
        });

        /* Calculate trigger counts */
        let totalExitCount = 0, expectedExitCount = 0;
        devicesShowing.forEach(device => {
            zonesShowing.forEach(zone => {
                let relevantTriggers = triggers.filter(trigger => (trigger.deviceId === device.identifier || trigger.deviceId === device._id) && trigger.zoneId === zone._id)
                let triggerCount = relevantTriggers.length;

                if (triggerCount === 1) {
                    triggerCounts.device[device._id].single++;
                    triggerCounts.zone[zone._id].single++;
                } else if (triggerCount > 1) {
                    triggerCounts.device[device._id].over++;
                    triggerCounts.zone[zone._id].over++;
                } else {
                    triggerCounts.device[device._id].miss++;
                    triggerCounts.zone[zone._id].miss++;
                }
                if( zone.name.endsWith("CO") ) {
                    let exitCount = triggers.filter(trigger => (trigger.deviceId === device.identifier || trigger.deviceId === device._id) && trigger.zoneId === zone._id && trigger.didExit).length;
                    triggerCounts.device[device._id].shouldExit += triggerCount;
                    triggerCounts.device[device._id].didExit += exitCount;
                    triggerCounts.zone[zone._id].shouldExit += triggerCount;
                    triggerCounts.zone[zone._id].didExit += exitCount;
                    expectedExitCount += triggerCount;
                    totalExitCount += exitCount;
                }
                if( relevantTriggers.length && relevantTriggers[0]) {
                    triggerCounts.device[device._id].tttTotal += relevantTriggers[0].timeSinceStart
                    triggerCounts.zone[zone._id].tttTotal += relevantTriggers[0].timeSinceStart
                }
            });
        });
        devicesShowing.forEach(device => {
            triggerCounts.device[device._id].tttAverage =  triggerCounts.device[device._id].tttTotal / (triggerCounts.device[device._id].single + triggerCounts.device[device._id].over)*1.0/1000
        })
        zonesShowing.forEach(zone => {
            triggerCounts.zone[zone._id].tttAverage =  triggerCounts.zone[zone._id].tttTotal / (triggerCounts.zone[zone._id].single + triggerCounts.zone[zone._id].over)*1.0/1000
        })

        /* Calculate trigger rates */

        Object.values(triggerCounts).forEach(triggerCountType => {
            Object.values(triggerCountType).forEach(triggerCount => {
                const { single, over, miss } = triggerCount,
                    success = showSinglePercentage ? single : single + over,
                    total = single + over + miss;

                triggerCount.rate = total ? (success / total * 100).toFixed(2) : 0;
                if( triggerCount.shouldExit )
                    triggerCount.exitRate = (triggerCount.didExit/triggerCount.shouldExit) * 100;
            });
        });
        return (
            <Fragment>
                <div className="matrix-analysis-main-div wide-view">
                    <h4 className="text-center">Matrix Analysis</h4>
                    <div className="matrix-analysis">
                        {!(testInstance && testInstance.scenario && testInstance.scenario.type == ScenarioTypes.STARTUP)? (
                        <MatrixAnalysisMenu
                            displayAsIcons={displayAsIcons}
                            displayTableByPlatform={displayTableByPlatform}
                            toggleShowSinglePercentage={this.props.toggleShowSinglePercentage}
                            toggleDisplayAsIcons={this.props.toggleDisplayAsIcons}
                            updateTableByPlatform={this.props.updateTableByPlatform}
                            showPanels={showPanels}
                            toggleShowPanels={this.props.toggleShowPanels}
                            toggleReadTriggersDataFromLogs={this.props.toggleReadTriggersDataFromLogs}
                            readTriggersDataFromLogs={readTriggersDataFromLogs}
                        />
                        ):""}
                        {showPanels
                            ? [
                                  <MatrixInfoPanel
                                      key={`info-panel`}
                                      devicesShowing={devicesShowing}
                                      zonesShowing={zonesShowing}
                                      testInstance={testInstance}
                                      triggerCounts={triggerCounts}
                                      showSinglePercentage={showSinglePercentage}
                                  />,
                                  <MatrixDeviceTable
                                      key={`device-table`}
                                      devices={devices}
                                      devicesShowing={devicesShowing}
                                      testInstance={testInstance}
                                      toggleSelectDevice={this.props.toggleSelectDevice}
                                      toggleShowDevice={this.props.toggleShowDevice}
                                      toggleShowAllDevices={this.props.toggleShowAllDevices}
                                      deviceTriggerCounts={triggerCounts.device}
                                      sort={sortDevices}
                                      sortAsc={sortDevicesAsc}
                                      updateSort={this.props.updateDevicesSortState}
                                  />,
                                  <MatrixZoneTable
                                      key={`zone-table`}
                                      zones={zones}
                                      zonesShowing={zonesShowing}
                                      testInstance={testInstance}
                                      toggleSelectZone={this.props.toggleSelectZone}
                                      toggleShowZone={this.props.toggleShowZone}
                                      toggleShowAllZones={this.props.toggleShowAllZones}
                                      zoneTriggerCounts={triggerCounts.zone}
                                      sort={sortZones}
                                      sortAsc={sortZonesAsc}
                                      updateSort={this.props.updateZonesSortState}
                                  />,
                              ]
                            : ``}
                        {!(testInstance && testInstance.scenario && testInstance.scenario.type == ScenarioTypes.STARTUP) ?
                            (<MatrixTable
                                devicesShowing={devicesShowing}
                                zonesShowing={zonesShowing}
                                triggers={triggers}
                                triggerCounts={triggerCounts}
                                displayAsIcons={displayAsIcons}
                                showSinglePercentage={showSinglePercentage}
                                toggleSelectDevice={this.props.toggleSelectDevice}
                                toggleSelectZone={this.props.toggleSelectZone}
                                isLoading={isLoading}
                                calculatedExitRate={(totalExitCount * 100 / expectedExitCount).toFixed(2)}
                            />)
                            :
                            (<MatrixStartupTable
                                devicesShowing={devicesShowing}
                                zonesShowing={zonesShowing}
                                triggers={triggers}
                                triggerCounts={triggerCounts}
                                displayAsIcons={displayAsIcons}
                                showSinglePercentage={showSinglePercentage}
                                toggleSelectDevice={this.props.toggleSelectDevice}
                                toggleSelectZone={this.props.toggleSelectZone}
                                isLoading={isLoading}
                                calculatedExitRate={(totalExitCount * 100 / expectedExitCount).toFixed(2)}
                            />)
                        }
                    </div>
                </div>
                {(testInstance && testInstance.scenario && testInstance.scenario.type == ScenarioTypes.FIELD)?
                    (<div className="matrix-analysis-main-div wide-view">
                    <h4 className="text-center">Time To Trigger</h4>
                    <div className="text-center">
                        <MatrixTimeToTriggerMenu
                            setTTTMetric={this.props.setTTTMetric}
                            tttMetric={tttMetric}
                            />
                    </div>
                    <div className="matrix-analysis">
                        <MatrixTimeToTriggerTable
                            devicesShowing={devicesShowing}
                            zonesShowing={zonesShowing}
                            triggers={triggers}
                            triggerCounts={triggerCounts}
                            displayAsIcons={displayAsIcons}
                            showSinglePercentage={showSinglePercentage}
                            toggleSelectDevice={this.props.toggleSelectDevice}
                            toggleSelectZone={this.props.toggleSelectZone}
                            isLoading={isLoading}
                            tttMetric={tttMetric}
                            />
                    </div>
                </div>):""}
                
                {(testInstance && testInstance.scenario && testInstance.scenario.type == ScenarioTypes.FIELD)?
                    (<div className="matrix-analysis-main-div wide-view">
                    <h4 className="text-center">Dwell Time</h4>
                    <div className="matrix-analysis">
                        <MatrixDwellTimeTable
                            devicesShowing={devicesShowing}
                            zonesShowing={zonesShowing}
                            triggers={triggers}
                            dwellEvents={dwellEvents}
                            displayAsIcons={displayAsIcons}
                            showSinglePercentage={showSinglePercentage}
                            toggleSelectDevice={this.props.toggleSelectDevice}
                            toggleSelectZone={this.props.toggleSelectZone}
                            isLoading={isLoading}
                            readTriggersDataFromLogs={readTriggersDataFromLogs}
                            />
                    </div>
                </div>):""}
                
                <MatrixFalseTriggerTable
                    zones={zones}
                    triggers={triggers}
                    devicesShowing={devicesShowing}
                    readTriggersDataFromLogs={readTriggersDataFromLogs}
                />
          
            </Fragment>
        );
    }
}

export default MatrixAnalysis;
